export const DEFAULT_EDITION = 'DefaultEdition';
export const COMMANDE_EDITION = 'CommandeEdition';
